import { PureComponent } from "react";
import YoutubeVideoWithPosterComponent from "components/core/youtube-video-with-poster/youtube-video-with-poster-component";
import ColorfulTitleComponent from "/components/core/colorful-title/colorful-title-component";
import LottieAnimationComponent from "../lottie-animtaion/lottie-animation-component";
import VideoDecoration from "/static/svg/decorators/main-video/top-left-decoration.svg";
import { componentStylesFactory } from "./main-youtube-video-component.scss";

const LOTTIE_ANIMATION_CONFIG = {
  animation: {
    jsonPath: "/static/lottie/arrow-turn-left.json",
    loop: false,
    autoplay: false,
    playOnlyWhenVisible: true
  },
  style: {}
};

export default class MainYoutubeVideoComponent extends PureComponent {
  render() {
    const { youtubeVideoId, poster, showDecorations, title, animationText, width, height } = this.props;
    const componentStyles = componentStylesFactory(width, height);

    return (
      <div className="main-youtube-video-component">
        <div className="video-component-wrapper">
          {showDecorations && (
            <div className="video-decoration-wrapper">
              <VideoDecoration />
            </div>
          )}
          <YoutubeVideoWithPosterComponent videoId={youtubeVideoId} poster={poster} muted={false} volume={100} />
          {showDecorations && (
            <div className="lottie-animation-wrapper">
              <LottieAnimationComponent {...LOTTIE_ANIMATION_CONFIG} />
              <div className="animation-text">{animationText}</div>
            </div>
          )}
        </div>
        {title && <ColorfulTitleComponent className="main-video-title" text={title} />}
        <style jsx>{componentStyles}</style>
      </div>
    );
  }
}

MainYoutubeVideoComponent.defaultProps = {
  showDecorations: true,
  youtubeVideoId: "1UbaEcto56k",
  poster: "/static/img/templates/long-template/segments/boards/board-with-cactus-and-phone.png",
  title: "monday.com in 60 sec",
  animationText: "Take a tour",
  width: "1050px",
  height: "570px"
};
